<div class="main" appViewportObserver (isVisible)="initData()">
  <div class="flex justify-between items-center gap-4">
    <h2 class="text-2xl">
      {{ DashboardTranslateKeys.JOB_OFFER_TRACK | translate }}
    </h2>
    <div class="header__splitter grow"></div>
    <p-button
      outlined="true"
      severity="secondary"
      (click)="toggleContent()"
      [icon]="isCollapsed() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
    />
  </div>
  <div
    class="content transition-all duration-300 ease-in-out overflow-hidden"
    [ngClass]="{
      'h-auto opacity-100': !isCollapsed(),
      'h-0 opacity-0': isCollapsed()
    }"
  >
    <div class="grid grid-cols-2 gap-3">
      <div class="stats__card">
        <h4 class="text-[#44546F] font-semibold">
          {{ DashboardTranslateKeys.OVERALL_STATUS_OFFERS | translate }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{ DashboardTranslateKeys.WHERE_RECRUITMENTS | translate }}
        </h5>
        <app-filters
          [showMonthYearPicker]="true"
          [disabled]="isLoadingOffersStats()"
          (monthYearPickerChanged)="updateOffersStatusMonthYear($event)"
        />
        <div class="mt-7">
          @if(isLoadingOffersStats()) {
          <app-skeleton-dash-card />
          } @else if(!chartOffersObjects.length) {
          <p class="text-center">
            {{ DashboardTranslateKeys.NO_DATA_FOUND | translate }}
          </p>
          } @else {
          @defer (on viewport; prefetch on idle) {
          <app-doughnut-chart
            id="offer-tracking"
            [objects]="chartOffersObjects"
          />
          } @placeholder {
          <app-skeleton-dash-card />
          }
          }
        </div>
      </div>
      <div class="stats__card">
        <h4 class="text-[#44546F] font-semibold">
          {{ DashboardTranslateKeys.OFFER_ACCEPTANCE_RATE | translate }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{ DashboardTranslateKeys.ACCEPTED_PROPOSED | translate }}
        </h5>
        <app-filters
          [showMonthYearPicker]="true"
          [firstSelectOptions]="firstFiltersOptions"
          [disabled]="isLoadingOffersAcceptance()"
          (monthYearPickerChanged)="updateOffersAcceptanceMonthYear($event)"
          (firstSelectChanged)="updateOffersAcceptanceJob($event)"
        />
        <div class="mt-7">
          @if(isLoadingOffersAcceptance()) {
          <app-skeleton-dash-card />
          } @else {
          <div class="flex items-center gap-5 opacity-60">
            <div class="flex flex-col gap-2">
              <span class="text-7xl">{{ offerAcceptanceAccepted() }}</span>
              <span>{{
                DashboardTranslateKeys.OFFERS_ACCEPTED | translate
              }}</span>
            </div>
            <div class="text-5xl">/</div>
            <div class="flex flex-col gap-2">
              <span class="text-7xl">{{ offerAcceptanceProposed() }}</span>
              <span>{{
                DashboardTranslateKeys.OFFERS_PROPOSED | translate
              }}</span>
            </div>
          </div>
          <div class="flex items-end mt-9">
            <span class="text-9xl">{{ offerAcceptancePercent() }}</span>
            <span class="text-5xl opacity-60 pb-3">%</span>
          </div>
          }
        </div>
      </div>
      <div class="stats__card">
        <h4 class="text-[#44546F] font-semibold">
          {{ DashboardTranslateKeys.OFFER_PER_STRUCTURE | translate }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{
            DashboardTranslateKeys.WHERE_RECRUITMENTS_PER_STRUCTURE | translate
          }}
        </h5>
        <app-filters
          [showYearPicker]="true"
          (yearPickerChanged)="updateOverallStructureStatusYear($event)"
          [disabled]="isLoadingOverallStatusPerStructure()"
        />
        <div class="mt-7">
          @if(isLoadingOverallStatusPerStructure() ||
          !chartOverallOfferStatusStructure) {
          <app-skeleton-dash-card />
          } @else {
          @defer (on viewport; prefetch on idle) {
          <app-multiple-column-chart
            id="offer-structure"
            [objects]="chartOverallOfferStatusStructure"
          />
          } @placeholder {
          <app-skeleton-dash-card />
          }
          }
        </div>
      </div>
      <div class="stats__card">
        <h4 class="text-[#44546F] font-semibold">
          {{
            DashboardTranslateKeys.OFFER_ACCEPTANCE_RATE_PER_STRUCTURE
              | translate
          }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{ DashboardTranslateKeys.ACCEPTED_PROPOSED_STRUCTURE | translate }}
        </h5>
        <app-filters
          [showYearPicker]="true"
          (yearPickerChanged)="updateOverallStructureAcceptenceYear($event)"
          [disabled]="isLoadingAcceptanceRatePerStructure()"
        />
        <div class="mt-7">
          @if(isLoadingAcceptanceRatePerStructure() ||
          !chartColumnAcceptanceRateStructure) {
          <app-skeleton-dash-card />
          } @else {
          @defer (on viewport; prefetch on idle) {
          <app-column-chart
            id="accept-structure"
            [objects]="chartColumnAcceptanceRateStructure"
          />
          } @placeholder {
          <app-skeleton-dash-card />
          }
          }
        </div>
      </div>
    </div>
  </div>
</div>
